export default "__VITE_ASSET__DRsKEIN$__"